import axios from "axios";
import getInterceptors from '@/modules/common/services/interceptors.js';

const HTTP = axios.create({
  baseURL: window.vue_config.VUE_APP_API_URL_GATEWAY
});

const serviceInterceptors = getInterceptors(HTTP);

HTTP.interceptors.request.use(
  serviceInterceptors.REQUEST.onFulfilled,
  serviceInterceptors.REQUEST.onRejected,
);

HTTP.interceptors.response.use(
  serviceInterceptors.RESPONSE.onFulfilled,
  serviceInterceptors.RESPONSE.onRejected,
);

const get = (route, params, options = {}) => {
  const config = {params};
  if (options.skipTeamsViewFilter) {
    config.skipTeamsViewFilter = true;
  }
  return HTTP.get(route, config).then(res => res.data);
}

const put = (route, params) => {
  return HTTP.put(route, params).then(res => res.data);
}

const post = (route, params) => {
  return HTTP.post(route, params).then(res => res.data);
}

const remove = (route, params) => {
  return HTTP.delete(route, params).then(res => res.data);
}

export default {
  get,
  put,
  remove,
  post
};
